export default __webpack_public_path__ + "static/media/priorBalance.055baeda.svg";